import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  structuredData?: object;
  noindex?: boolean;
}

export const SEOHead = ({
  title,
  description,
  keywords = "mobile mechanic, car service, Gold Coast, automotive repair, pre-purchase inspection, diagnostics, car servicing, brake repair, battery replacement",
  canonical,
  ogImage = "https://www.carguroo.com.au/og-image.jpg",
  structuredData,
  noindex = false
}: SEOProps) => {
  const fullTitle = title.includes('Carguroo') ? title : `${title} | Carguroo - Mobile Mechanic Gold Coast`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Carguroo Mobile Mechanics" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {!noindex && <meta name="robots" content="index,follow" />}
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_AU" />
      <meta property="og:site_name" content="Carguroo Mobile Mechanics" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@carguroo" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional Meta Tags for Local Business */}
      <meta name="geo.region" content="AU-QLD" />
      <meta name="geo.placename" content="Gold Coast" />
      <meta name="geo.position" content="-28.0167;153.4000" />
      <meta name="ICBM" content="-28.0167, 153.4000" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};